var map = {
	"./ascending-order.svg": 87752,
	"./avatar.svg": 10256,
	"./column-interaction.svg": 44718,
	"./descending-order.svg": 83594,
	"./export.svg": 3205,
	"./fit-screen.svg": 62345,
	"./heading.svg": 50275,
	"./search.svg": 64343,
	"./zoom-in.svg": 6270,
	"./zoom-out.svg": 98073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;